import { Row, Col, Spin } from "antd";
import StatCard from "components/statCard";
import {
  TrendingUp,
  Calendar,
  UserRound,
  Dumbbell,
  UserRoundCog,
} from "lucide-react";
import React, { useEffect, useState } from "react";

const BranchStats = ({ values }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({ userAdmin: 0, users: 0, control: 0 });

  useEffect(() => {
    if (!values || !Array.isArray(values)) return;

    setIsLoading(true);

    const stats = values.reduce(
      (acc, item) => {
        acc.userAdmin += item.userAdmin || 0;
        acc.users += item.user || 0;
        acc.control += item.control || 0;
        return acc;
      },
      { userAdmin: 0, users: 0, control: 0 }
    );

    setData(stats);
    setIsLoading(false);
  }, [values]);
  return (
    <Spin spinning={isLoading}>
      <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
        <Col xs={24} sm={12} md={8} style={{ minWidth: 250 }}>
          <StatCard
            title={data.userAdmin}
            subtitle="Professores"
            icon={<UserRoundCog size={18} color="#fff" />}
            iconColor="#16C60C"
          />
        </Col>

        <Col xs={24} sm={12} md={8} style={{ minWidth: 260 }}>
          <StatCard
            title={data.users}
            subtitle="Alunos"
            icon={<UserRound size={18} color="#fff" />}
            iconColor="#2C2C2C"
          />
        </Col>

        <Col xs={24} sm={12} md={8} style={{ minWidth: 300 }}>
          <StatCard
            title={data.control}
            subtitle="Treinos Efetuados"
            icon={<Dumbbell size={18} color="#fff" />}
            iconColor="#FDBA63"
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default BranchStats;
